module.exports = __webpack_public_path__ + "img/remote_work.0329b0bb.jpg";